import React, { useState } from 'react';
import { FaPlus, FaTimes } from 'react-icons/fa';
import '../styles/CreateProject.css';

function CreateProject({ navigateToSwitchProject }) {
  const [projectName, setProjectName] = useState('');
  const [projectDescription, setProjectDescription] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [contributors, setContributors] = useState('');
  const [location, setLocation] = useState('');
  const [budget, setBudget] = useState('');
  const [isPrivate, setIsPrivate] = useState(false);

  const handleClearProjectName = () => {
    setProjectName('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle project creation logic here
    console.log({
      projectName,
      projectDescription,
      startDate,
      endDate,
      contributors,
      location,
      budget,
      isPrivate
    });

    navigateToSwitchProject();
  };

  const handleCancel = () => {
    // Clear form or navigate back
    setProjectName('');
    setProjectDescription('');
    setStartDate('');
    setEndDate('');
    setContributors('');
    setLocation('');
    setBudget('');
    setIsPrivate(false);
  };

  return (
    <div className="create-project-container">
      <h2>Create New Project</h2>
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>
            <FaPlus className="icon-prefix" />
            Project Name
          </label>
          <div className="input-with-clear">
            <input
              type="text"
              placeholder="Project Name"
              value={projectName}
              onChange={(e) => setProjectName(e.target.value)}
            />
            {projectName && (
              <button 
                type="button" 
                className="clear-button"
                onClick={handleClearProjectName}
              >
                <FaTimes />
              </button>
            )}
          </div>
        </div>

        <div className="form-group">
          <label>
            <img src="/icons/description.svg" alt="" className="icon-prefix" />
            Project Description
          </label>
          <textarea
            placeholder="Project Description"
            value={projectDescription}
            onChange={(e) => setProjectDescription(e.target.value)}
          />
        </div>

        <div className="date-row">
          <div className="form-group date-field">
            <label>
              <img src="/icons/calendar.svg" alt="" className="icon-prefix" />
              Start Date
            </label>
            <input
              type="date"
              placeholder="Start Date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>

          <div className="form-group date-field">
            <label>
              <img src="/icons/calendar.svg" alt="" className="icon-prefix" />
              End Date
            </label>
            <input
              type="date"
              placeholder="End Date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
        </div>

        <div className="form-group">
          <label>
            <img src="/icons/contributors.svg" alt="" className="icon-prefix" />
            Project Contributors
          </label>
          <input
            type="text"
            placeholder="Project Contributors"
            value={contributors}
            onChange={(e) => setContributors(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>
            <img src="/icons/location.svg" alt="" className="icon-prefix" />
            Location
          </label>
          <input
            type="text"
            placeholder="Location"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>
            <img src="/icons/budget.svg" alt="" className="icon-prefix" />
            Budget
          </label>
          <input
            type="text"
            placeholder="Budget"
            value={budget}
            onChange={(e) => setBudget(e.target.value)}
          />
        </div>

        <div className="form-group toggle-group">
          <label>
            <img src="/icons/private.svg" alt="" className="icon-prefix" />
            Private Project
          </label>
          <div className="toggle-switch">
            <input
              type="checkbox"
              id="privateToggle"
              checked={isPrivate}
              onChange={() => setIsPrivate(!isPrivate)}
            />
            <label htmlFor="privateToggle" className="toggle-label"></label>
          </div>
        </div>

        <div className="form-actions">
          <button type="button" className="cancel-button" onClick={handleCancel}>Cancel</button>
          <button type="submit" className="submit-button">Submit</button>
        </div>
      </form>
    </div>
  );
}

export default CreateProject; 